export default {
  title: {
    id: 'product_page_new_battery_modal_title',
    defaultMessage: 'New battery',
  },
  section1Title: {
    id: 'product_page_new_battery_modal_section1_title',
    defaultMessage: 'What battery do you need?',
  },
  section1Description: {
    id: 'product_page_new_battery_modal_section1_description',
    defaultMessage:
      'If you prefer 100% battery capacity to the high functioning 85%, a new battery might be for you. It’s perfect if you use your phone for games or work.',
  },
  section1Note: {
    id: 'product_page_new_battery_modal_note',
    defaultMessage:
      '*Battery capacity is the amount of energy a battery can hold, also considered the leading health indicator for a battery.',
  },
  section1Link: {
    id: 'product_page_new_battery_modal_link',
    defaultMessage: 'Learn more about new batteries',
  },
  section2Title: {
    id: 'product_page_new_battery_modal_section2_title',
    defaultMessage: 'Frequently Asked Questions',
  },
}
